'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _formatting = require('../../utils/formatting');

var _demographicRow = require('./demographic-row');

var _demographicRow2 = _interopRequireDefault(_demographicRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DemographicsLocationTable = function DemographicsLocationTable(_ref) {
  var data = _ref.data,
      uniqueKey = _ref.uniqueKey,
      metric = _ref.metric,
      itemLabel = _ref.itemLabel,
      metricLabel = _ref.metricLabel,
      rowsToShow = _ref.rowsToShow;

  var rows = _lodash2.default.orderBy(data, metric, ['desc']);
  var displayed = rowsToShow < 0 ? rows : _lodash2.default.take(rows, rowsToShow);
  var restOfTheWorld = _lodash2.default.filter(data, function (item) {
    return !_lodash2.default.find(displayed, [uniqueKey, item[uniqueKey]]);
  });
  var totalMetric = _lodash2.default.sumBy(rows, metric);
  return _react2.default.createElement(
    _semanticUiReact.Table,
    { basic: 'very', columns: 'three', singleLine: true, textAlign: 'center' },
    _react2.default.createElement(
      _semanticUiReact.Table.Header,
      null,
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { textAlign: 'left' },
          itemLabel
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          metricLabel || _lodash2.default.startCase(metric)
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          'Percentage'
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Body,
      null,
      _lodash2.default.map(displayed, function (row) {
        return _react2.default.createElement(_demographicRow2.default, {
          row: row,
          metric: metric,
          uniqueKey: uniqueKey,
          totalMetric: totalMetric
        });
      }),
      !_lodash2.default.isEmpty(restOfTheWorld) && _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { textAlign: 'left' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'globe', color: 'pink' }),
          '  Rest of World'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfTheWorld, metric))
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(restOfTheWorld, function (row) {
            return row.percentage || 100 * row[metric] / totalMetric;
          })),
          ' %'
        )
      )
    )
  );
};

DemographicsLocationTable.propTypes = {
  data: _propTypes2.default.object.isRequired,
  metric: _propTypes2.default.string.isRequired,
  itemLabel: _propTypes2.default.string,
  metricLabel: _propTypes2.default.string,
  uniqueKey: _propTypes2.default.string,
  rowsToShow: _propTypes2.default.number
};

DemographicsLocationTable.defaultProps = {
  metricLabel: undefined,
  uniqueKey: 'countryCode',
  itemLabel: 'Country',
  rowsToShow: 5
};

exports.default = DemographicsLocationTable;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/demographics-location-table/index.js
 ** module id = 146
 ** module chunks = 0
 **/